

























import {Vue, Component} from 'vue-property-decorator';

@Component({
  name: 'Logo',
})
export default class Logo extends Vue {
}
